export default __webpack_public_path__ + "static/step3-eb7b780fb4f8339c78f5ccae9bb50bfd.jpeg";